module.exports = __webpack_public_path__ + "assets/HKNova-Thin.eot";


//////////////////
// WEBPACK FOOTER
// ./fonts/HKNova-Thin.eot
// module id = 147
// module chunks = 0